// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
export const environment = {
  name: 'Artaah',
  theme: 'sgs',
  production: true,
  environmentName: 'sgs-production',
  // Service slots (pickup/delivery windows) always render in KSA time (UTC+3).
  serviceTimeZoneOffset: '+0300' as string | undefined,
  hmr: false,
  enableApplePay: false,
  enableCustomerAnalytics: false,
  enableGoogleAnalytics: true,
  enableChatbot: false,
  authType: 'local',
  version: require('../../package.json').version + '-sgs-production',
  appVersion: require('../../package.json').version + '-sgs-production',
  serverUrl: 'https://bountyportalbackendhelper.azurewebsites.net',

  skuUrl: 'https://ahoyskus.azurewebsites.net',
  vsUrl: 'https://ahoyvirtualstoremerchant.azurewebsites.net',

  hadirUrl: 'https://hadiradminportalapi.azurewebsites.net/',
  hadirSmsUrl: 'https://sgssmsapi.azurewebsites.net',

  deliveryUrl: 'https://ahoydelivery.azurewebsites.net',
  merchantUrl: 'https://ahoydeliverymerchant.azurewebsites.net',
  transactionsUrl: 'https://ahoytransaction.azurewebsites.net',
  profileUrl: 'https://ahoyprofile.azurewebsites.net',

  ahoyAuthUrl: 'https://artaah-prod-backend.azurewebsites.net/customer',
  sgsCustomerUrl: 'https://artaah-prod-backend.azurewebsites.net/customer',
  signalRUrl: 'https://artaah-prod-backend.azurewebsites.net',

  authAuthApi: 'https://ahoyauthapi.azurewebsites.net',
  googlePlacesUrl: 'https://maps.googleapis.com',

  activeDirectoryUrl: 'auth/token',
  refreshTokenUrl: 'auth/refresh-token',
  activeDirectoryClientId: '346aa65f-2e42-451e-b77c-59ba4acacd6b',
  activeDirectoryScope: '',

  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'ar'],
  google_api_key: 'AIzaSyAAVVmfkjLNhBMOkkTgDbuuRw5gJbPc6rI',
  here_maps_key: 'ILHL3c2NkYfUOc6JL1cseBxBCknCpjbHMbKwHFpTD8M',

  // TODO: swap for a dedicated sgs-production Firebase project once provisioned
  firebase: {
    apiKey: 'AIzaSyBi405fulvJYi5QvcjYmqzDFEZ89ocdVBo',
    authDomain: 'sgs-artaah-customer.firebaseapp.com',
    projectId: 'sgs-artaah-customer',
    storageBucket: 'sgs-artaah-customer.firebasestorage.app',
    messagingSenderId: '614869284143',
    appId: '1:614869284143:web:139a9ca2fc833f3a7c1dda',
    measurementId: 'G-BLD8R31PP9',
  },

  airlineCode: 'SVA',
  countrySettings: {
    country: 'KSA',
    countryNameCode: 'KSA',
    countryCode: '966',
    currency: 'SAR',
    currencyId: 1,
    minAgeForAccountOpening: 18,
    defaultLatitude: 24.7082,
    defaultLongitude: 46.6893,
    nationalAddress: true,
    cities: [
      {
        id: 101,
        name: 'Riyadh',
      },
      {
        id: 102,
        name: 'Jeddah',
      },
      {
        id: 103,
        name: 'Dammam',
      },
      {
        id: 104,
        name: 'Makah',
      },
      {
        id: 105,
        name: 'Al Hofuf',
      },
      {
        id: 106,
        name: 'AL KHOBAR',
      },
      {
        id: 107,
        name: 'AL DHAHRAN',
      },
      {
        id: 108,
        name: 'AL QATIF',
      },
      {
        id: 109,
        name: 'RAS TANURAH',
      },
      {
        id: 110,
        name: 'Al Jubail',
      },
      {
        id: 111,
        name: 'AL JUBAIL INDUSTRIAL',
      },
      {
        id: 112,
        name: 'Madina',
      },
      {
        id: 113,
        name: 'Taif',
      },
    ],
    availableTemperatures: [12],
    cashAvailable: true,
    cardAvailable: false,
  },
};
